<template>
  <v-list-group>
    <template v-slot:activator>
      <v-list-item-action>
        <v-icon>mdi-eye</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          Ansicht
        </v-list-item-title>
      </v-list-item-content>
    </template>

    <v-list-item
      v-for="setting in settings"
      :key="setting.id"
      @click="updateProfile(setting.id)"
      :title="setting.name"
    >
      <v-list-item-action>
        <v-checkbox
           :input-value="profile[setting.id]"
           @click.prevent.stop=""
           @change="updateProfile(setting.id)"
        />
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          {{ setting.name }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list-group>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      settings: [
         {
          id: 'show_inactive_projects',
          name: 'Inaktive Projekte einblenden',
          checked: false
        },
        {
          id: 'show_inactive_employees',
          name: 'Inaktive Mitarbeiter einblenden',
          checked: false
        },
        {
          id: 'show_project_color',
          name: 'Projekte einfärben',
          checked: false
        },
        {
          id: 'show_employee_color',
          name: 'Mitarbeiter einfärben',
          checked: false
        },
        {
          id: 'show_operation',
          name: 'Tätigkeiten einblenden',
          checked: false
        },
        {
          id: 'show_employee_name',
          name: 'Mitarbeiternamen einblenden',
          checked: false
        },
        {
          id: 'show_place_and_journey',
          name: 'Ort und Reisestrecke einblenden',
          checked: false
        },
        {
          id: 'format_date_with_day',
          name: 'Wochentage einblenden',
          checked: false
        },
        {
          id: 'format_hour_as_number',
          name: 'Zeiträume als Stunden anzeigen',
          checked: false
        }
      ],
    }
  },
  computed: {
    ...mapGetters([
      'profile',
      'profileLoading',
    ]),
  },
  methods: {
    ...mapActions(['setProfile']),
    updateProfile (name) {
      let p = {}
      p[name] = !this.profile[name]
      this.setProfile({profile: p})
    }
  },
}
</script>
